import { Component, OnInit, OnDestroy } from '@angular/core';
import { UserListItem } from '../../models/user-list.model';
import { ActivatedRoute, Router } from '@angular/router';
import { UserCriteria } from '../../models/user.criteria';
import { UserService } from '../../services/user.service';
import { SortItem } from 'src/app/core/models/sort-item.model';
import { ProgressBarService } from 'src/app/core/services/progress-bar.service';
import * as moment from 'moment';
import { EntityDatatableComponent } from 'src/app/core/components/entity-datatable/entity-datatable.component';
import { EntityListRefresh } from 'src/app/core/services/entity-list.refresh';

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.css'],
  host: { 'class': 'content' }
})
export class UserComponent extends EntityDatatableComponent<UserListItem, UserCriteria, UserService> implements OnInit, OnDestroy {

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    userService: UserService,
    entityListRefresh: EntityListRefresh,
    progressBarService: ProgressBarService
  ) {
    super(
      'user',
      new UserCriteria(),
      entityListRefresh,
      userService,
      progressBarService
    );

    this.sortItems = [
      {
        title: 'user.surname',
        code: 'Surname',
        sortOrder: 'asc',
        width: 156,
        disabled: false,
        isEmpty: false,
        class: null
      },
      {
        title: 'user.email',
        code: 'Email',
        sortOrder: 'asc',
        width: 156,
        disabled: false,
        isEmpty: false,
        class: 'd-none d-sm-table-cell'
      },
      {
        title: 'user.company',
        code: 'CompanyName',
        sortOrder: 'asc',
        width: 210,
        disabled: false,
        isEmpty: false,
        class: 'd-none d-sm-table-cell'
      },
      {
        title: 'user.phone',
        code: 'Phone',
        sortOrder: 'asc',
        width: 110,
        disabled: false,
        isEmpty: false,
        class: 'd-none d-md-table-cell'
      },
      {
        title: 'user.lastLogin',
        code: 'LastLogin',
        sortOrder: 'asc',
        width: 180,
        disabled: false,
        isEmpty: false,
        class: 'd-none d-xl-table-cell'
      },
      {
        title: 'user.active',
        code: 'IsActive',
        sortOrder: 'asc',
        width: 80,
        disabled: true,
        isEmpty: false,
        class: null
      },
      {
        title: 'user.action',
        code: 'action',
        sortOrder: 'asc',
        width: 50,
        disabled: true,
        isEmpty: true,
        class: null
      }
    ];
  }

  ngOnInit() {
    this.initData(this.route.snapshot.data.users);
  }

  ngOnDestroy() {
    this.destroyData();
  }

  activeFilter(filterTerm: string) {
    this.criteria.filterActive = filterTerm;
    this.criteria.page = 1;
    this.reloadData();
  }

  search(term: string) {
    this.criteria.searchTerm = term;
    this.criteria.page = 1;
    this.reloadData();
  }

  createUser() {
    this.router.navigate([{ outlets: { modal: 'create-user' } }]);
  }

  goToDetail(id: number) {
    this.router.navigate([{ outlets: { modal: ['user-detail', id] } }]);
  }

  formatLastLogin(item: UserListItem) {
    if (!item.lastLogin) {
      return '-';
    }
    const lastLogin = moment(item.lastLogin);
    return lastLogin.format('DD.MM.YYYY HH:mm');
  }

  formatIsActive(item: UserListItem) {
    if (item.isActive) {
      return 'Ano';
    } else {
      return 'Ne';
    }
  }

}
